import React, { useEffect, useState } from "react";

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField
} from "@mui/material";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";

const CloseTaskDialog = ({
    open,
    onClose,
    onSubmit
}) => {

    const [comments, setComments] = useState("");

    const handleSubmit = () => {
        if (!comments.trim()) {
            return;
        }

        onSubmit(comments.trim());
    };

    const handleClose = () => {
        setComments("");
        onClose();
    };

    return (
        <ThemeProvider>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>
                    Complete Task
                </DialogTitle>

                <DialogContent>
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        label="Comments"
                        required
                        value={comments}
                        onChange={(e) =>
                            setComments(e.target.value)
                        }
                        sx={{ mt: 1 }}
                        placeholder="Enter comments before completing the task"
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose}>
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={!comments.trim()}
                    >
                        Complete Task
                    </Button>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
};

export default CloseTaskDialog;